import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export const SkeletonClients = () => {
  return (
    <tr className="client-list-row-data">
      <td style={{ width: "80px" }}>
        <Skeleton />
      </td>
      <td>
        <Skeleton />
      </td>
      <td style={{ width: "150px" }}>
        <Skeleton count={2} />
      </td>
      <td style={{ width: "150px" }}>
        <Skeleton count={3} />
      </td>
      <td style={{ width: "150px" }}>
        <Skeleton count={4} />
      </td>
      <td>
        <Skeleton />
      </td>
      <td>
        <Skeleton />
      </td>
    </tr>
  );
};

export const SkeletonClientHistory = () => {
  return (
    <tr>
      <td>
        <Skeleton />
      </td>
      <td>
        <Skeleton />
      </td>
      <td>
        <Skeleton />{" "}
      </td>
      <td style={{ width: "120px" }}>
        <Skeleton count={3} />
      </td>
      <td>
        <Skeleton />
      </td>
      <td>
        <Skeleton />
      </td>
      <td>
        <Skeleton />
      </td>
      <td>
        <Skeleton />
      </td>
      <td style={{ width: "150px" }}>
        <Skeleton count={4} />
      </td>
    </tr>
  );
};
